import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

/**
 * Collapsible panel — keeps long create forms tucked away until needed.
 */
const AdminCollapsibleSection = ({
  title,
  description,
  defaultOpen = false,
  badge,
  children,
  footer,
}) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="rounded-2xl border border-slate-200 bg-white overflow-hidden">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between gap-3 px-4 sm:px-5 py-4 text-left hover:bg-slate-50/80 transition"
        aria-expanded={open}
      >
        <div className="min-w-0">
          <div className="flex flex-wrap items-center gap-2">
            <h3 className="text-base font-semibold text-[#011337]">{title}</h3>
            {badge ? (
              <span className="text-xs px-2 py-0.5 rounded-full bg-slate-100 text-slate-600">{badge}</span>
            ) : null}
          </div>
          {description ? <p className="text-sm text-slate-500 mt-1">{description}</p> : null}
        </div>
        <ChevronDown
          size={20}
          className={`shrink-0 text-slate-500 transition-transform ${open ? "rotate-180" : ""}`}
        />
      </button>

      {open ? (
        <div className="px-4 sm:px-5 pb-5 border-t border-slate-100">
          <div className="pt-4">{children}</div>
          {footer ? <div className="mt-4 flex flex-wrap justify-end gap-2">{footer}</div> : null}
        </div>
      ) : null}
    </div>
  );
};

export default AdminCollapsibleSection;
